import React from "react";
import { EWsrvTransform, IMediaItem } from "../../lib";
import { ILinkFunc } from "../../lib/util";
import { WsrvImage } from "../Media";
import Heading from "./Heading";
import { Button } from "../Button";

export interface IContentCard {
  image?: IMediaItem;
  header?: string;
  text?: string;
  link?: { label?: string; url: string };
}

export interface IContentCardsBladeProps {
  className?: string;
  title?: string;
  titleHeadingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
  titleClassName?: string;
  headingCTA?: { href: string; text?: string; target?: string }
  contentCards: IContentCard[];
  linkFunc?: ILinkFunc;
}

export const ContentCardsBlade: React.FC<IContentCardsBladeProps> = ({
  className = "",
  title,
  titleHeadingLevel = "h1",
  titleClassName = "",
  headingCTA,
  contentCards,
  linkFunc,
}) => {
  const linkf = linkFunc || ((props) => <a {...props} />);

  let cards: JSX.Element[] = [];
  contentCards &&
    contentCards.forEach((item: IContentCard, index: number) => {
      let cardImage = undefined
      item.image?.url && (cardImage = (
        <WsrvImage
          urlParams={{
            originURL: item.image.url,
            preset: EWsrvTransform.cover3x2,
          }}
          widthMax={441}
          imgProps={{
            className: "max-w-full",
          }}
        />
      ));

      cardImage && item.link &&
        (cardImage =
          linkf({ href: item.link.url, children: cardImage, key: index }) ??
          cardImage);

      let card = (
        <>
          {cardImage}
          {item.header &&
            <h3
              className={`font-bold italic md:text-lg lg:text-xl pt-3 pb-1.5 px-4 md:px-0 xl:px-4`}
            >
              {item.header}
            </h3>}
          {item.text &&
            <div
              className={`text-base md:text-sm lg:text-base px-4 md:px-0 xl:px-4`}
              dangerouslySetInnerHTML={{ __html: item.text }}
            ></div>
          }
        </>
      );

      cards.push(card);
    });

  let titleLayout = "text-center"
  if (headingCTA?.href) {
    titleLayout = "flex flex-row justify-between"
  }

  return (
    <section
      className={`grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-3 lg:gap-5 xl:gap-7 ${className}`}
    >
      {title && <Heading
        headingLevel={titleHeadingLevel}
        className={`${titleLayout} md:col-span-3 ${titleClassName}`}
      >
        {title}
        {headingCTA?.href && (
          <Button
            linkFunc={linkf}
            linkProps={{
              className: "hidden lg:block",
              href: headingCTA.href,
              target: headingCTA.target
            }}
          >
            {headingCTA.text}
          </Button>
        )}
      </Heading>
      }
      {cards &&
        cards.map((card: JSX.Element, index: number) => (
          <article key={index}>{card}</article>
        ))}
      {headingCTA?.href && (
        <div className="md:col-span-3 w-full flex flex-row justify-end lg:hidden">
          <Button
            linkFunc={linkf}
            linkProps={{
              href: headingCTA.href,
              target: headingCTA.target
            }}
          >
            {headingCTA.text}
          </Button>
        </div>
      )}
    </section>
  );
};

export default ContentCardsBlade;